// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.channel-members-list{width:100%;border-collapse:collapse;background:#fff;border-radius:2px;overflow:hidden;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}table.channel-members-list thead td{padding:8px;background:#00183d;text-transform:uppercase;color:#fa0019;font-size:.8em;font-weight:bold}table.channel-members-list tbody td{padding:8px}table.channel-members-list tbody tr:nth-child(even){background:#f0f1f2}", ""]);
// Exports
module.exports = exports;
